import { useState, useEffect } from "react";
import { api } from "../utils/api";
import { Bell, Plus, Trash2, Check, X, Loader2, RefreshCw, Send, Users, Bike, Megaphone } from "lucide-react";

const T = { primary:"#f97316",primaryDark:"#ea580c",primaryLight:"#fff7ed",primaryMid:"#fed7aa",white:"#ffffff",bg:"#f1f5f9",text:"#0f172a",textSub:"#64748b",textMuted:"#94a3b8",border:"#e2e8f0",green:"#16a34a",greenLight:"#dcfce7",red:"#ef4444",redLight:"#fef2f2",blue:"#2563eb",blueLight:"#eff6ff",purple:"#7c3aed",purpleLight:"#f5f3ff" };

const TYPE_MAP = {
  promo:  { label:"Promo",  color:T.primary, bg:T.primaryLight, Icon:Megaphone },
  order:  { label:"Order",  color:T.blue,    bg:T.blueLight,    Icon:Bell      },
  system: { label:"System", color:T.purple,  bg:T.purpleLight,  Icon:Bell      },
  rider:  { label:"Rider",  color:T.green,   bg:T.greenLight,   Icon:Bike      },
};

const EMPTY = { title:"", message:"", type:"promo", target:"all" };

function NotifModal({ onClose, onSend }) {
  const [form,   setForm]   = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  const handleSend = async () => {
    if (!form.title || !form.message) return alert("Title aur message required hai!");
    setSaving(true);
    const res = await api.notifications.create(form);
    setSaving(false);
    if (res.success) onSend(res.data);
    else alert(res.message||"Error!");
  };

  return (
    <div onClick={onClose} style={{ position:"fixed",inset:0,background:"rgba(0,0,0,0.45)",zIndex:400,display:"flex",alignItems:"center",justifyContent:"center",padding:16 }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:T.white,borderRadius:20,width:"100%",maxWidth:420,boxShadow:"0 20px 60px rgba(0,0,0,0.15)",overflow:"hidden" }}>
        <div style={{ padding:"16px 18px",borderBottom:`1px solid ${T.border}`,display:"flex",alignItems:"center",justifyContent:"space-between" }}>
          <div style={{ fontFamily:"'Fraunces',Georgia,serif",fontWeight:900,fontSize:"1rem" }}>Send Notification</div>
          <button onClick={onClose} style={{ background:T.bg,border:"none",borderRadius:"50%",width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer" }}><X size={15} color={T.textSub}/></button>
        </div>
        <div style={{ padding:18,display:"flex",flexDirection:"column",gap:12 }}>
          <div>
            <label style={{ fontSize:"0.72rem",fontWeight:700,color:T.textMuted,display:"block",marginBottom:5 }}>Title *</label>
            <input value={form.title} onChange={e=>set("title",e.target.value)} placeholder="Big Sale Today!"
              style={{ width:"100%",border:`1.5px solid ${T.border}`,borderRadius:10,padding:"9px 12px",fontSize:"0.85rem",fontFamily:"inherit",color:T.text,outline:"none",boxSizing:"border-box" }}/>
          </div>
          <div>
            <label style={{ fontSize:"0.72rem",fontWeight:700,color:T.textMuted,display:"block",marginBottom:5 }}>Message *</label>
            <textarea value={form.message} onChange={e=>set("message",e.target.value)} rows={3}
              placeholder="Get 30% off on all orders today! Use code SAVE30"
              style={{ width:"100%",border:`1.5px solid ${T.border}`,borderRadius:10,padding:"9px 12px",fontSize:"0.85rem",fontFamily:"inherit",color:T.text,outline:"none",resize:"vertical",boxSizing:"border-box" }}/>
          </div>
          <div style={{ display:"flex",gap:10 }}>
            <div style={{ flex:1 }}>
              <label style={{ fontSize:"0.72rem",fontWeight:700,color:T.textMuted,display:"block",marginBottom:5 }}>Type</label>
              <select value={form.type} onChange={e=>set("type",e.target.value)}
                style={{ width:"100%",border:`1.5px solid ${T.border}`,borderRadius:10,padding:"9px 12px",fontSize:"0.85rem",fontFamily:"inherit",color:T.text,background:T.white }}>
                <option value="promo">Promotional</option>
                <option value="order">Order Update</option>
                <option value="system">System</option>
                <option value="rider">Rider</option>
              </select>
            </div>
            <div style={{ flex:1 }}>
              <label style={{ fontSize:"0.72rem",fontWeight:700,color:T.textMuted,display:"block",marginBottom:5 }}>Target</label>
              <select value={form.target} onChange={e=>set("target",e.target.value)}
                style={{ width:"100%",border:`1.5px solid ${T.border}`,borderRadius:10,padding:"9px 12px",fontSize:"0.85rem",fontFamily:"inherit",color:T.text,background:T.white }}>
                <option value="all">All Users</option>
                <option value="customers">Customers Only</option>
                <option value="riders">Riders Only</option>
              </select>
            </div>
          </div>

          {/* Preview */}
          <div style={{ background:T.bg,borderRadius:12,padding:"12px 14px",border:`1px solid ${T.border}` }}>
            <div style={{ fontSize:"0.62rem",fontWeight:700,color:T.textMuted,marginBottom:8,textTransform:"uppercase" }}>Preview</div>
            <div style={{ display:"flex",gap:10,alignItems:"flex-start" }}>
              <div style={{ width:36,height:36,borderRadius:10,background:`linear-gradient(135deg,${T.primaryDark},${T.primary})`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0 }}>
                <Bell size={18} color="#fff"/>
              </div>
              <div>
                <div style={{ fontWeight:700,fontSize:"0.85rem",color:T.text }}>{form.title||"Notification Title"}</div>
                <div style={{ fontSize:"0.75rem",color:T.textSub,marginTop:3 }}>{form.message||"Your message here..."}</div>
              </div>
            </div>
          </div>

          <button onClick={handleSend} disabled={saving}
            style={{ background:`linear-gradient(135deg,${T.primaryDark},${T.primary})`,border:"none",borderRadius:12,padding:"12px",color:"#fff",fontWeight:800,fontSize:"0.88rem",cursor:"pointer",fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",gap:6 }}>
            {saving?<Loader2 size={16} className="spin"/>:<Send size={16}/>} Send Notification
          </button>
        </div>
      </div>
    </div>
  );
}

export default function NotificationsPage() {
  const [notifs,  setNotifs]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal,   setModal]   = useState(false);
  const [toast,   setToast]   = useState("");

  const showToast = m => { setToast(m); setTimeout(()=>setToast(""),2200); };

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.notifications.getAll();
      if (res.success) setNotifs(res.data);
    } catch { showToast("Backend connect nahi hua"); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const handleDelete = async (id) => {
    const res = await api.notifications.delete(id);
    if (res.success) { setNotifs(n => n.filter(x => x._id!==id)); showToast("Deleted!"); }
  };

  const handleSend = (data) => {
    setNotifs(n => [data,...n]);
    setModal(false);
    showToast("Notification sent!");
  };

  return (
    <div style={{ fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
      <style>{`@keyframes fadeUp{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}} @keyframes spin{to{transform:rotate(360deg)}}.spin{animation:spin 1s linear infinite}`}</style>

      {toast && (
        <div style={{ position:"fixed",top:80,left:"50%",transform:"translateX(-50%)",background:T.text,color:"#fff",padding:"10px 20px",borderRadius:100,fontSize:"0.82rem",fontWeight:600,zIndex:500,display:"flex",alignItems:"center",gap:7 }}>
          <Check size={14} color={T.green}/> {toast}
        </div>
      )}

      <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:12 }}>
        <div>
          <div style={{ fontFamily:"'Fraunces',Georgia,serif",fontWeight:900,fontSize:"1.1rem",color:T.text }}>Notifications</div>
          <div style={{ fontSize:"0.72rem",color:T.textMuted,marginTop:2 }}>{notifs.length} sent total</div>
        </div>
        <div style={{ display:"flex",gap:8 }}>
          <button onClick={load} style={{ background:T.white,border:`1px solid ${T.border}`,borderRadius:10,padding:"8px 14px",cursor:"pointer",display:"flex",alignItems:"center",gap:6,fontSize:"0.78rem",fontWeight:600,color:T.textSub,fontFamily:"inherit" }}>
            <RefreshCw size={14} className={loading?"spin":""}/> Refresh
          </button>
          <button onClick={()=>setModal(true)} style={{ background:T.primary,border:"none",borderRadius:10,padding:"9px 18px",fontWeight:700,fontSize:"0.85rem",color:"#fff",cursor:"pointer",display:"flex",alignItems:"center",gap:6,fontFamily:"inherit" }}>
            <Plus size={16}/> Send Notification
          </button>
        </div>
      </div>

      {loading ? (
        <div style={{ textAlign:"center",padding:60,color:T.textMuted }}>Loading...</div>
      ) : notifs.length === 0 ? (
        <div style={{ textAlign:"center",padding:60 }}>
          <Bell size={44} color={T.border} style={{ marginBottom:12 }}/>
          <div style={{ color:T.textMuted,fontWeight:600 }}>Koi notifications nahi abhi tak</div>
        </div>
      ) : (
        <div style={{ display:"flex",flexDirection:"column",gap:10 }}>
          {notifs.map((n,i) => {
            const tm = TYPE_MAP[n.type] || TYPE_MAP.promo;
            const TIcon = tm.Icon;
            return (
              <div key={n._id} style={{ background:T.white,borderRadius:14,border:`1px solid ${T.border}`,padding:"14px 16px",display:"flex",alignItems:"flex-start",gap:12,animation:`fadeUp .3s ${i*.04}s ease both` }}>
                <div style={{ width:40,height:40,borderRadius:12,background:tm.bg,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0 }}>
                  <TIcon size={18} color={tm.color}/>
                </div>
                <div style={{ flex:1,minWidth:0 }}>
                  <div style={{ display:"flex",alignItems:"center",gap:8,marginBottom:3,flexWrap:"wrap" }}>
                    <div style={{ fontWeight:700,fontSize:"0.88rem",color:T.text }}>{n.title}</div>
                    <span style={{ background:tm.bg,color:tm.color,fontSize:"0.6rem",fontWeight:700,padding:"2px 7px",borderRadius:100 }}>{tm.label}</span>
                    <span style={{ background:T.bg,color:T.textSub,fontSize:"0.6rem",fontWeight:600,padding:"2px 7px",borderRadius:100 }}>{n.target}</span>
                  </div>
                  <div style={{ fontSize:"0.78rem",color:T.textSub,marginBottom:6 }}>{n.message}</div>
                  <div style={{ fontSize:"0.68rem",color:T.textMuted }}>{new Date(n.createdAt).toLocaleString("en-IN",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"})}</div>
                </div>
                <button onClick={()=>handleDelete(n._id)}
                  style={{ background:T.redLight,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0 }}>
                  <Trash2 size={14} color={T.red}/>
                </button>
              </div>
            );
          })}
        </div>
      )}

      {modal && <NotifModal onClose={()=>setModal(false)} onSend={handleSend}/>}
    </div>
  );
}